import {keepPreviousData} from "@tanstack/react-query";
import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {PageResponse} from "~/services/ApiTypes";
import {supplierParentNamesUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {SupplierParentName} from "~/pages/supplier-360/types/Supplier360Types";

export function useSupplierParentNamesQuery(
    databagId: number,
    search: string,
    pageSize: number,
    enabled: boolean,
) {
    const url = supplierParentNamesUrl(databagId, search, pageSize);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<PageResponse<SupplierParentName>>(url)).data.results,
        enabled: enabled && Boolean(databagId),
        placeholderData: keepPreviousData,
    });
}
